<container kind="mini">
  <page-intro-header title="{{ 'DUTY_PROCEEDINGS_INITIATION.TITLE' | translate }}">
  </page-intro-header>
  
  <mat-card class="card duty-proceedings-initiation-wrapper">
    <form class="form" [formGroup]="dutyProceedingsForm">
      <div class="button-add-holder">
        <button mat-flat-button color="primary" (click)="importSubjectData()">
          <mat-icon>person_add</mat-icon>
          {{ "GLOBAL.IMPORT_SUBJECT" | translate }}
        </button>
      </div>

      <form-subgroup-divider></form-subgroup-divider>
    
    <field-holder kind="3-cols">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.FIRST_NAME" | translate }}
        </mat-label>
        <input matInput type="text" readonly formControlName="firstName" autocomplete="off" />
        <mat-error *ngIf="dutyProceedingsForm.get('firstName').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.FIRST_NAME_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
      
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.LAST_NAME" | translate }}
        </mat-label>
        <input matInput type="text" readonly formControlName="lastName" autocomplete="off" />
        <mat-error *ngIf="dutyProceedingsForm.get('lastName').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.LAST_NAME_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
      
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.REGISTRATION_NUMBER" | translate }}
        </mat-label>
        <input matInput type="text" readonly formControlName="registrationNumber" autocomplete="off" />
        <mat-error *ngIf="dutyProceedingsForm.get('registrationNumber').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.REGISTRATION_NUMBER_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
    
    <field-holder kind="2-cols-1-2">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.JMBG" | translate }}
        </mat-label>
        <input matInput type="text" readonly formControlName="jmbg" autocomplete="off" />
        <mat-error *ngIf="dutyProceedingsForm.get('jmbg').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.JMBG_ERROR" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "DUTY_PROCEEDINGS_INITIATION.CASE_CLASSIFICATION" | translate }}</mat-label>
        <input type="text" matInput formControlName="caseClassification" (focusout)="checkClasificationCase(false)" [matAutocomplete]="autoCaseClassification" autocomplete="off" />
        <mat-autocomplete #autoCaseClassification="matAutocomplete" [displayWith]="displayClassification">
          <mat-option *ngFor="let option of filteredCaseClassifications | async" [value]="option">
            {{ option.code }} | {{ option.title }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="dutyProceedingsForm.get('caseClassification').hasError('required') || dutyProceedingsForm.get('caseClassification').hasError('notValid')">
          {{ "DUTY_PROCEEDINGS_INITIATION.CASE_CLASSIFICATION_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
    
    <field-holder kind="1-col">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.REASON_FOR_PROCEDURE" | translate }}
        </mat-label>
        <textarea matInput formControlName="reasonForProcedure" rows="4" autocomplete="off"></textarea>
        <mat-error *ngIf="dutyProceedingsForm.get('reasonForProcedure').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.REASON_FOR_PROCEDURE_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>

    <form-subgroup-divider></form-subgroup-divider>
    
    <field-holder kind="2-cols">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.DATE" | translate }}
        </mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" autocomplete="off" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="dutyProceedingsForm.get('date').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.DATE_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
      
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "DUTY_PROCEEDINGS_INITIATION.PROFESSIONAL_WORKER" | translate }}
        </mat-label>
        <input matInput type="text" readonly formControlName="professionalWorker" autocomplete="off" />
        <mat-error *ngIf="dutyProceedingsForm.get('professionalWorker').hasError('required')">
          {{ "DUTY_PROCEEDINGS_INITIATION.PROFESSIONAL_WORKER_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
    
    <form-subgroup-divider></form-subgroup-divider>
    
    <div class="button-save-holder">
      <button mat-flat-button color="primary" (click)="saveDecision()" [disabled]="!dutyProceedingsForm.valid">
        {{ "DUTY_PROCEEDINGS_INITIATION.SAVE_DECISION" | translate }}
      </button>
    </div>

    
    </form>
  </mat-card>
</container>
